import React, { useEffect, useContext } from "react";
import { AppContext, useAppContext } from "./AppContext";
import { useHistory, useParams, useLocation } from "react-router-dom";

export default function Unauthorized() {
  const history = useHistory();

  const { CartAmount, setCartAmount, setWishList, WishList } =
    useContext(AppContext);
  const handleDivClick = (profilecomp) => {
    //window.location.assign(`/${profilecomp}`); // Full reload, but keeps history
    history.push(`/${profilecomp}`); // Navigate to the root path
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      localStorage.clear();
      setCartAmount(0);
      setWishList([]);
      handleDivClick("");
      window.location.reload();
      console.log("This runs after 10 seconds!");
    }, 10000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        paddingTop: 50,
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <a style={{ fontSize: 20, fontWeight: "500" }}>
        you will log out automatic after 10 second!
      </a>

      <a>Unauthorized, you dont have permission, because your role!</a>
    </div>
  );
}
